import {RecordForm} from '../forms/RecordForm';


import {useRegistrar} from '../hooks/useRegistrar';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    // No id on the Add page, so there is no record to load — the form starts
    // blank. The Redux selector returned loosely-typed `any`; React Query types
    // it honestly as undefined (FNP-943).
    const {createRecord} = useRegistrar();

    return (
        <FormPageLayout
            title='Add Registrar'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
